import { Component, OnInit } from '@angular/core';
import {CacheService} from '../../shared/services/cache.service';
import {AlertService} from '../../shared/services/alert.service';

@Component({
    selector: 'app-admin-tools',
    templateUrl: './admin-tools.component.html',
    styleUrls: ['./admin-tools.component.scss'],
    standalone: false
})
export class AdminToolsComponent implements OnInit {

  constructor(private cache: CacheService, private alert: AlertService) { }

  ngOnInit(): void {
  }

  clearCache()
  {
    this.cache.clear().subscribe( () => {

      this.alert.success('Cache cleared');

    });
  }

}
